import { combineReducers } from 'redux';

import superSystemCouponsReducer from './superSystemCouponsReducer';
import superSystemBetSlipReducer from './superSystemBetSlipReducer';
import superSystemValidatedReducer from './superSystemValidatedReducer';
import superSystemPlayedCouponsReducer from './superSystemPlayedCouponsReducer';

export default combineReducers({
  coupons: superSystemCouponsReducer,
  betSlip: superSystemBetSlipReducer,
  validated: superSystemValidatedReducer,
  playedCoupons: superSystemPlayedCouponsReducer
});
